import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import ModeEditRoundedIcon from "@mui/icons-material/ModeEditRounded";

import Form from "./Form";
import graph from "./graph";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useLazyQuery, useMutation } from "@apollo/client";
import { isEmptyObject } from "helpers/formatObject";
import {
  NewDialog,
  NewDialogTitle,
  NewDialogActions,
  NewDialogContent,
} from "components";
import { FormattedMessage } from "react-intl";
import { CircularProgress, Stack } from "@mui/material";
import { fetchUser } from "toolkits/redux/auth";

export default function UpdatePopup({ title = "ویرایش اطلاعات" }) {
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({});
  const { userToken } = useSelector((state) => state.auth);
  const [fetchModel, { loading }] = useLazyQuery(graph.get.query);
  const [updateModel, { loading: updating }] = useMutation(graph.update.query);

  const onOpen = () => setOpen(true);
  const onClose = () => setOpen(false);

  const getModel = async () => {
    try {
      const { data } = await fetchModel({
        context: {
          serviceName: graph.get.serviceName,
          headers: {
            authorization: `Bearer ${userToken}`,
          },
        },
      });
      if (!isEmptyObject(data)) {
        const res = data[graph.get.name];
        if (res) {
          const {
            id,
            email,
            gender,
            lastname,
            firstname,
            birth_date,
            skin_color,
            national_code,
          } = res;
          setFormData({
            ids: id,
            email,
            gender,
            lastname,
            firstname,
            birth_date,
            skin_color,
            national_code,
          });
        }
      }
    } catch (error) {}
  };

  const onChange = ({ formData }) => {
    setFormData(formData);
  };

  const onSubmit = async () => {
    try {
      const { data, errors } = await updateModel({
        context: {
          serviceName: graph.update.serviceName,
          headers: {
            authorization: `Bearer ${userToken}`,
          },
        },
        variables: formData,
      });
      if (!errors) {
        onClose();
        dispatch(fetchUser(userToken));
        if (!isEmptyObject(data)) {
          data[graph.update.name]?.messages.map((message) =>
            toast.success(String(message))
          );
        }
      }
    } catch (error) {
      setFormData(formData);
    }
  };

  useEffect(() => {
    open && getModel();
  }, [open]);

  return (
    <>
      <Button
        fullWidth
        color="info"
        onClick={onOpen}
        sx={{ bgcolor: "action.hover" }}
      >
        ویرایش
      </Button>
      <NewDialog label="update" open={open} onClose={onClose} maxWidth="sm">
        <NewDialogTitle title={title} onClose={onClose} />
        <NewDialogContent>
          {loading ? (
            <Stack
              rowGap={3}
              py={2}
              alignItems="center"
              justifyContent="center"
              height={140}
            >
              <CircularProgress />
            </Stack>
          ) : (
            <Stack p={2} alignItems="center">
              <Form formData={formData} onChange={onChange} />
            </Stack>
          )}
        </NewDialogContent>
        <NewDialogActions>
          <Button
            autoFocus
            size="large"
            color="primary"
            variant="contained"
            disabled={loading || updating}
            onClick={onSubmit}
            sx={{ minWidth: 80 }}
          >
            <FormattedMessage id="update" />
          </Button>
        </NewDialogActions>
      </NewDialog>
    </>
  );
}
